import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class HeaderService {
  constructor() { }

  private setHeaderDataEvent: EventEmitter<any> = new EventEmitter();
  private setProfileChangeEvent: EventEmitter<any> = new EventEmitter();
  private setSubHeaderDataEvent: EventEmitter<any> = new EventEmitter();
  private subHeaderCallbackEvent: EventEmitter<any> = new EventEmitter();

  /**
   * It set header data i.e. { title : "", breadCrumb : [] }
   * @param _data header data
   */
  setHeaderData(_data: any) {
    this.setHeaderDataEvent.emit(_data);
  }

  /**
   * Method to get subscribe to header data change
   * @returns event
   */
  getHeaderEmitter(): EventEmitter<any> {
    return this.setHeaderDataEvent;
  }

  setProfileChangeData(_data: any) {
    this.setProfileChangeEvent.emit(_data);
  }

  getProfileChangeEmitter(): EventEmitter<any> {
    return this.setProfileChangeEvent;
  }

  /**
   * It set sub-header data i.e. { label : [], selectedTab : 1 }
   * @param _data sub header data
     */
  setSubHeaderData(_data: any) {
    this.setSubHeaderDataEvent.emit(_data);
  }

  /**
   * Method to get subscribe to sub-header data change
   * @returns sub header data event
     */
  getSubheaderEmitter(): EventEmitter<any> {
    return this.setSubHeaderDataEvent;
  }

  /**
   * Method to set sub-header callback event
   * @param eventName name of event
   * @param _data data
     */
  triggerSubHeaderCallbackEvent(eventName: string, _data: any) {
    _data.eventName = eventName;
    this.subHeaderCallbackEvent.emit(_data);
  }

  /**
   * Method to get subscribed to sub-header callback event
   * @returns event
   */
  getSubheaderCallbackEmitter(): EventEmitter<any> {
    return this.subHeaderCallbackEvent;
  }

}







